const toSafeText = (value, fallback = "-") => {
  if (value === null || value === undefined || value === "") return fallback;
  return String(value);
};

const orderTypeLabel = {
  tables: "طاولة",
  table: "طاولة",
  takeaway: "تيك اواي",
  take_away: "تيك اواي",
  delivery: "دليفري",
  delivary: "دليفري",
};

const formatTimeOnly = (value) => {
  const match = String(value || "").match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?$/);
  if (!match) return null;

  const date = new Date();
  date.setHours(Number(match[1]), Number(match[2]), Number(match[3] || 0), 0);

  return date.toLocaleTimeString("ar-EG", {
    hour: "numeric",
    minute: "2-digit",
    second: match[3] ? "2-digit" : undefined,
    hour12: true,
  });
};

const formatDateTime = (value) => {
  if (!value) return "-";

  const timeOnly = formatTimeOnly(value);
  if (timeOnly) return timeOnly;

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return toSafeText(value);

  return date.toLocaleString("ar-EG", {
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

const normalizeOrderType = (value, tableNumber = "") => {
  const orderType = orderTypeLabel[value] || toSafeText(value);
  const safeTableNumber = toSafeText(tableNumber, "");

  if (orderType === "طاولة" && safeTableNumber) {
    return `طاولة ${safeTableNumber}`;
  }

  return orderType;
};

const resolveItemName = (item = {}) =>
  item?.product_name ||
  item?.drink_name ||
  item?.name ||
  item?.product?.name ||
  item?.product?.product_name ||
  item?.drinks?.drink_name ||
  item?.drinks?.name ||
  item?.drink?.drink_name ||
  item?.drink?.name ||
  (item?.product_id ? `منتج #${item.product_id}` : null) ||
  (item?.drink_id ? `مشروب #${item.drink_id}` : null) ||
  (item?.drinks?.id ? `مشروب #${item.drinks.id}` : null) ||
  "-";

const resolveItemsList = (payload = {}) => {
  if (Array.isArray(payload)) return payload;

  const root = payload?.order ? payload.order : payload;
  const items =
    root?.items ||
    root?.order_items ||
    root?.orderItems ||
    payload?.items ||
    payload?.order_items ||
    [];

  if (Array.isArray(items) && items.length) return items;

  const looksLikeSingleItem =
    root?.quantity !== undefined ||
    root?.product_name ||
    root?.drink_name ||
    root?.product ||
    root?.drinks ||
    root?.product_id ||
    root?.drink_id;

  return looksLikeSingleItem ? [root] : [];
};

export const normalizePreprationItemForPrint = (item = {}) => ({
  id: item?.id ?? null,
  name: toSafeText(resolveItemName(item)),
  quantity: toSafeText(item?.quantity ?? item?.qty),
  note: toSafeText(item?.note ?? item?.notes),
  addedAt: formatDateTime(item?.added_at || item?.created_at || item?.open_time),
});

export const normalizeOrderForPrint = (payload = {}) => {
  const root = payload?.order ? payload.order : payload;
  const meta = payload?.meta || root?.meta || {};
  const orderType = meta.orderType || root?.order_type || root?.orderType || root?.type;
  const tableNumber =
    meta.tableNumber ||
    root?.table_number ||
    root?.table_no ||
    root?.table?.number ||
    root?.table?.name ||
    root?.table_name ||
    root?.table_id ||
    payload?.table_number ||
    payload?.table_id ||
    "";
  const printTime =
    meta.printTime ||
    root?.preparation_print_time ||
    root?.print_time ||
    payload?.preparation_print_time ||
    payload?.print_time ||
    new Date();

  return {
    meta: {
      orderNumber: toSafeText(
        meta.orderNumber ||
          payload?.order_number ||
          root?.order_number ||
          root?.general_increment ||
          root?.daily_increment ||
          root?.id ||
          root?.order_id
      ),
      orderType: normalizeOrderType(orderType, tableNumber),
      tableNumber: toSafeText(tableNumber),
      printTime: formatDateTime(printTime),
    },
    items: resolveItemsList(payload).map(normalizePreprationItemForPrint),
  };
};

export const normalizeOrderForPreprationPrint = normalizeOrderForPrint;
